import React from 'react';
import { MdClose, MdErrorOutline } from 'react-icons/md';


const ProductUnavailableModal = ({ product, isOpen, onClose }) => {
  if (!isOpen || !product) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container unavailable-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="modal-close-btn" onClick={onClose}>
          <MdClose size={24} />
        </button>

        {/* Modal Header */}
        <div className="modal-header unavailable">
          <MdErrorOutline size={48} className="error-icon" />
          <h2>Product Unavailable</h2>
        </div>

        {/* Modal Body */}
        <div className="modal-body unavailable">
          <div className="product-details">
            <h3>{product.productName}</h3>
            <div className="details-row">
              <span className="label">Category:</span>
              <span className="value">{product.category}</span>
            </div>
            <div className="details-row">
              <span className="label">Price:</span>
              <span className="value">₹{product.price}</span>
            </div>
            <div className="details-row stock-status">
              <span className="label">Stock Status:</span>
              <span className="value out-of-stock">Out of Stock</span>
            </div>
          </div>

          <div className="unavailable-message">
            <p>
              Unfortunately, this product is currently out of stock and has been marked as unavailable.
            </p>
            <p className="sub-message">
              We apologize for the inconvenience. Please check back soon for availability or explore similar products.
            </p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="modal-footer unavailable">
          <button className="btn-primary" onClick={onClose}>
            Back to Shopping
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Explore Similar Products
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductUnavailableModal;
